<div class="container">
  <div class="text-center">
    <h1 i18n="@@contactUsTitle">Get in Touch with Us</h1>
    <p class="page-subtitle" i18n="@@contactUsBusinessSubtitle">We’re here for you. Contact Akl Bayti for Any Assistance or Information You Need</p>
  </div>
  <div class="contact-us-details">
    <div class="contact-us-details-img-div">
      <img src="assets/contact-us.png">
    </div>

    <div class="contact-us-details-content-div">
      <div class="contact-us-message">
        <p i18n="@@contactUsMessage">If you have any questions, feedback, or need assistance, please
          reach out to us. Our team is dedicated to providing you with the support you need. We look forward to hearing
          from you!</p>
      </div>
      <div class="contact-info">
        <img src="assets/email.svg">
<!--        <div>-->
<!--          <div class="contact-info-title"><p i18n="@@emailLabel">Email</p></div>-->
          <div class="contact-info-value"><p>hello@aklbayti.com</p></div>
<!--        </div>-->
      </div>
    </div>
  </div>
</div>
